__turbopack_context__.v({
  "amityLogo": "Header-module-scss-module__4yRrGq__amityLogo",
  "divider": "Header-module-scss-module__4yRrGq__divider",
  "header": "Header-module-scss-module__4yRrGq__header",
  "inner": "Header-module-scss-module__4yRrGq__inner",
  "jioPcIconPlaceholder": "Header-module-scss-module__4yRrGq__jioPcIconPlaceholder",
  "jioPcName": "Header-module-scss-module__4yRrGq__jioPcName",
  "loginBtn": "Header-module-scss-module__4yRrGq__loginBtn",
});
